// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e6L3","questions":"styles_questions__1h3lo","footer":"styles_footer__2Q4xo"};